/* eslint-disable lines-between-class-members */

import jwtDecode from 'jwt-decode';

export default class User {
    static from(token) {
        try {
            const obj = jwtDecode(token);
            return new User(obj);
        } catch (_) {
            return null;
        }
    }

    constructor({email = '', fname = '', found = false, fullid = '', fullphone = '', id = '', lname = '', name = ''}) {
        this.id = id;
        this.fullid = fullid;
        this.fname = fname;
        this.lname = lname;
        this.name = name;
        this.email = email;
        this.fullphone = fullphone;
        this.found = found;
    }
}